import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";
import { apiGet, apiPost, apiPut } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getSurveyResultsFromAPI = async (token, survey_id) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet(`/surveyresults/${survey_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const getSurveyResultsWithUserFromAPI = async (token, survey_id, user_id) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet(`/surveyresults/${survey_id}/${user_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const updateSurveyResultFromAPI = async (obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPost('/surveyresults', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const completeSurveyResultFromAPI = async (obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPut('/surveyresults', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
